//TODO: adding ErrorBoundaries to PointsForDrawingsList
//? Question: config.site fallback is not an option for PointsForDrawingsList options?

//TODO: getTelescriptItem can be moved to the sg-ui-components

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import { getCMSObject, PointsForDrawingsList } from 'sg-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Drawings = ({ user, config, cmsSourceFirebase, actions, pointsForDrawings, match }) => {
    const [pageLoaded, setPageLoaded] = useState(false);
    useEffect(() => {
        async function fetchData() {
            await actions?.pointsForDrawingsActions?.getPointsForDrawings();
            setPageLoaded(true);
        }

        fetchData();
    }, [user.loggedIn, setPageLoaded]);

    const filterDrawingsByCategory = (drawings, category) => drawings?.filter((item) => item.category === category);
    const getTelescriptItem = (key) => getCMSObject(`data.components.teleScripts.${key}.jsonBlock`);

    const commonOptions = {
        pointIcon: <FontAwesomeIcon className='pfd-point-icon' icon='fa-solid fa-wallet' size={16} />,
        entryIcon: <FontAwesomeIcon className='pfd-entry-icon' icon='fa-solid fa-ticket' size={18} />,
        hasCollapser: true,
    };

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <div className='my-drawings-container'>
                <div className='col-12'>
                    <PointsForDrawingsList
                        config={config}
                        action={actions}
                        user={user}
                        mode={'show-limited'}
                        data={filterDrawingsByCategory(pointsForDrawings.pointsForDrawings, 'current')}
                        pageLoaded={pageLoaded}
                        telescript={getTelescriptItem('currentPointsForDrawings')}
                        drawings={pointsForDrawings}
                        options={{
                            ...commonOptions,
                            variant: 'theme-primary current-pfd',
                            dateIcon: <FontAwesomeIcon className='pfd-date-icon' icon='far fa-clock' size={18} />,
                            exclamationDateIcon: <FontAwesomeIcon className='pfd-date-icon' icon='fa-solid fa-triangle-exclamation' size={18} />,
                        }}
                    />
                    <PointsForDrawingsList
                        config={config}
                        action={actions}
                        user={user}
                        mode={'show-limited'}
                        data={filterDrawingsByCategory(pointsForDrawings.pointsForDrawings, 'expired')}
                        pageLoaded={pageLoaded}
                        telescript={getTelescriptItem('pastPointsForDrawings')}
                        drawings={pointsForDrawings}
                        hideLoadingAndEmptyStates={true}
                        options={{
                            ...commonOptions,
                            variant: 'theme-primary',
                            dateIcon: <FontAwesomeIcon icon='fa-solid fa-triangle-exclamation' className='pfd-date-icon' size={18} />,
                            exclamationDateIcon: <FontAwesomeIcon className='pfd-date-icon' icon='fa-solid fa-triangle-exclamation' size={18} />,
                        }}
                    />
                    <PointsForDrawingsList
                        config={config}
                        action={actions}
                        user={user}
                        mode={'show-limited'}
                        data={filterDrawingsByCategory(pointsForDrawings.pointsForDrawings, 'future')}
                        pageLoaded={pageLoaded}
                        telescript={getTelescriptItem('futurePointsForDrawings')}
                        drawings={pointsForDrawings}
                        hideLoadingAndEmptyStates={true}
                        options={{
                            ...commonOptions,
                            variant: 'theme-primary',
                            dateIcon: <FontAwesomeIcon className='pfd-date-icon' icon='fa-solid fa-clock' size={18} />,
                            exclamationDateIcon: <FontAwesomeIcon className='pfd-date-icon' icon='fas fa-triangle-exclamation' size={18} />,
                        }}
                    />
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Drawings);
